import Vue from 'vue';
import ContactService from '@/services/contact';

import { FETCH_ALL, REMOVE, SAVE } from '../actions.types';
import {
  SET_ERROR,
  SET_ITEM,
  SET_ITEMS,
  SET_FILTERS,
  REMOVE_ITEM
} from '../mutations.types';

export default {
  namespaced: true,
  state: {
    error: null,
    items: [],
    pagination: {},
    filters: {
      page: 1,
      sort: 'name',
      reverse: true
    }
  },
  actions: {
    async [FETCH_ALL]({ commit, state }) {
      try {
        const response = await ContactService.query(state.filters);
        commit(SET_ITEMS, response.data);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [REMOVE]({ commit }, contact) {
      try {
        await ContactService.delete(contact.id);
        commit(REMOVE_ITEM, contact);
      } catch (error) {
        commit(SET_ERROR, error.data);
        return Promise.reject(error.data);
      }
    },
    async [SAVE]({ commit }, contact) {
      try {
        await ContactService.save(contact.id, contact);
        commit(SET_ITEM, contact);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    }
  },
  mutations: {
    [SET_ERROR](state, error) {
      state.error = error;
    },
    [SET_ITEM](state, contact) {
      state.error = null;
      const index = state.items.findIndex(item => item.id === contact.id);
      Vue.set(state.items, index, contact);
    },
    [SET_ITEMS](state, response) {
      state.error = null;
      state.items = response.data;
      Vue.set(state, 'pagination', response.meta);
    },
    [SET_FILTERS](state, filters) {
      if (!filters.value) {
        Vue.set(state.filters, 'page', 1);
        Vue.delete(state.filters, filters.key);
      } else {
        Vue.set(state.filters, filters.key, filters.value);
      }
    },
    [REMOVE_ITEM](state, contact) {
      state.error = null;
      const index = state.items.findIndex(item => item.id == contact.id);
      state.items.splice(index, 1);
    }
  }
};
